module.exports = __webpack_public_path__ + "static/media/wishlist-icon.ba5951bf.svg";